import type {DefaultError} from "@tanstack/react-query";
import {isAxiosError} from "axios";
import type {UrlQueryKey} from "~/query/queryClient";
import {useCustomQuery} from "~/query/queryClient";

/** Response from `GET /api/showcase/contract_coverage_report/{id}/`. */
export type SupplierOverview = {
    parent: string;
    title: string;
    html: string;
};

export const contractCoverageReportUrl = (id: string) =>
    `/showcase/contract_coverage_report/${id}/`;

export const supplierOverviewQueryKey = (id: string) =>
    [contractCoverageReportUrl(id)] as const satisfies UrlQueryKey;

/**
 * Fetches the contract analysis overview report for a parent supplier.
 */
export function useSupplierOverviewQuery(id: string | null | undefined) {
    const enabled = Boolean(id);
    return useCustomQuery<
        SupplierOverview,
        DefaultError,
        SupplierOverview,
        UrlQueryKey
    >({
        queryKey: enabled
            ? supplierOverviewQueryKey(id!)
            : ["/showcase/contract_coverage_report/"],
        enabled,
        retry: (failureCount, error) => {
            if (isAxiosError(error) && error.response?.status === 404) {
                return false;
            }
            return failureCount < 2;
        },
    });
}
